import { useQuery } from '@tanstack/react-query';
import { email } from '@repletoryreach/sdk-api';

/**
 * Whether email exists for this account, asked once and shared.
 *
 * Email goes through a provider the platform chooses (4 October 2026), the
 * same arrangement as SMS. Until one is set up, the console offers nothing of
 * it: no Email choice in a broadcast, no Send an email step in a flow. Anything
 * short of a clear yes (a failed request, a service that is not deployed, an
 * answer that says off) counts as no, the same rule as SMS and Voice.
 */
export function useEmailStatus() {
  const q = useQuery({
    queryKey: ['email-status'],
    queryFn: () => email.getStatus(),
    staleTime: 60_000,
    retry: false
  });
  const status = q.data?.data ?? null;
  return { status, available: status?.available === true, isPending: q.isPending, refetch: q.refetch };
}
